<template>
  <div>
    <h3 class="-mt-10 font-semibold text-xl text-root-2 text-center text-white">
      {{ assetDetails.type }} Wallet
    </h3>
    <!--change initial asset form -->
    <el-form
      label-position="top"
      :model="assetForm"
      ref="assetForm"
      :rules="rules"
      label-width="80px"
      size="normal"
    >
      <div class="flex flex-col items-center justify-center mt-2 qr-code">
        <div class="px-10 flex flex-col items-center justify-center w-full">
          <section class="mt-5 top px-3 lg:px-5 py-3 mb-3 w-full">
            <p
              class="text-xs font-thin text-white flex items-center justify-between"
            >
              <span>Amount</span>
              <span>Amount</span>
            </p>
            <p
              class="flex items-center justify-between text-white font-semibold mt-1 lg:text-lg"
            >
              <span>$20</span>
              <span>$2,000.00</span>
            </p>
          </section>
          <div class="my-5 flex items-center">
            <p class="top px-2 py-1.5 rounded-full flex items-center gap-x-2">
              <currency-icons
                :currency="getCurrencyCountry(assetDetails.type)"
              />
              <span class="text-gray-300 text-xs font-normal">
                {{ assetDetails.type }}
              </span>
            </p>
            <p
              class="top px-4 py-2 rounded-full -ml-2 opacity-50 text-gray-300 relative z-10"
            >
              {{ parseNetworkName(assetDetails.network) }}
            </p>
          </div>
          <div class="border border-opacity-80 border-gray-400 rounded-2xl p-5">
            <qrcode-vue :value="walletAddress" :size="180" level="H" />
          </div>
          <p class="text-xs font-normal text-light mt-5 text-gray-300">
            Scan address to make deposit
          </p>
        </div>
        <!-- address -->
        <div
          class="w-full text-xs font-normal text-light flex flex-col items-center justify-center px-5 py-2.5"
        >
          <div class="flex items-center justify-between gap-x-2 top p-2 w-full">
            <p class="text-gray-300 text-center font-semibold w-full">
              {{ maskWalletAddress(walletAddress) }}
            </p>
            <div
              class="cursor-pointer mb-1 ml-2"
              v-clipboard:copy="walletAddress"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >
              <copy-icon />
            </div>
          </div>
        </div>
      </div>
      <!-- note -->
      <div class="flex items-center justify-center mt-2 w-11/12 mx-auto">
        <div
          class="flex items-center justify-center gap-x-2 px-3 py-2 rounded-md shadow-sm border bg-white"
        >
          <warning-icon-2 size="h-4 w-4" color="black" />
          <p class="text-gray-600 text-xs font-light">
            Only send {{ assetDetails.type }}
            {{ parseNetworkName(assetDetails.network) }} to this address
          </p>
        </div>
      </div>
      <!--transfer complete -->
      <el-form-item class="mt-16">
        <o-button @click="transferMade('assetForm')"
          >Confirm Payment ({{ 20.0 }})</o-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import breakpoints from '@/utils/breakpoints.js'
import { STABLE_COINS } from '@/utils/constants'
import QrcodeVue from 'qrcode.vue'
import {
  ParseMoneyAll,
  MaskWalletAddress,
  GetCurrencyCountry,
  ParseNetworkName
} from '@/utils/helpers'
import country from '@/mixins/getCountryDetails.js'
export default {
  name: 'DepositWallet',
  mixins: [country],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      walletAddress: '',
      stableCoins: STABLE_COINS,
      assetForm: {
        asset: '',
        network: ''
      },
      rules: {
        asset: [
          {
            required: true,
            message: 'Please select an asset',
            trigger: ['blur', 'change']
          }
        ],
        network: [
          {
            required: true,
            message: 'Please select a network',
            trigger: ['blur', 'change']
          }
        ]
      },
      assetDetails: {
        type: 'USDC',
        network: 'erc-30'
      }
    }
  },
  components: {
    CopyIcon: () => import('@/assets/icons/CopyIcon.vue'),
    WarningIcon2: () => import('@/assets/icons/WarningIcon2.vue'),
    CurrencyIcons: () => import('@/assets/icons/CurrencyIcons.vue'),
    QrcodeVue
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '27%' : breakpoints.mdAndUp ? '70%' : '90%'
    }
  },
  methods: {
    parseNetworkName (networkType) {
      return ParseNetworkName(networkType)
    },
    parseMoneyAll (amount, currency) {
      return ParseMoneyAll(amount, currency)
    },
    onCopy: function (e) {
      this.$notify.success({
        title: 'Copied'
      })
    },
    onError: function (e) {
      this.$notify.error('Error copying to clipboard!')
    },
    maskWalletAddress (walletAddress) {
      return MaskWalletAddress(walletAddress)
    },
    transferMade (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const payload = {
            paymentMethod: {},
            view: 'transaction-processing'
          }
          this.$emit('setView', payload)
          return valid
        } else {
          this.$notify.error({
            title: 'Invalid Asset',
            message: 'select an asset',
            position: 'top-right'
          })
        }
      })
    },
    getWalletAddress () {
      const vm = this
      if (this.$store.state.auth.WalletAddresses !== null) {
        const walletId = this.$store.state.auth.WalletAddresses.find(
          (wallet) =>
            wallet.wallet_type === this.assetDetails.type &&
            wallet.reason === 'transfer'
        )
        if (walletId) {
          this.walletAddress = walletId.wallet_address
          return walletId.wallet_address
        } else {
          vm.$message({
            showClose: true,
            message: `You do not have a wallet address for ${this.country.currency}`,
            type: 'info',
            duration: 6000
          })
        }
      } else {
        vm.$message({
          showClose: true,
          message:
            'Your account is awaiting futher verification once that is done the disabled payment method would be enabled.',
          type: 'info',
          duration: 6000
        })
      }
    },
    getCurrencyCountry (val) {
      return GetCurrencyCountry(val)
    }
  },
  mounted () {
    this.getWalletAddress()
  }
}
</script>

<style scoped>
.qr-code {
  box-shadow: 0px 2px 3px rgba(2, 1, 1, 0.09);
  border-radius: 11px;
}
.address {
  background: #f5f6fb;
  opacity: 0.66;
  border-radius: 0px 0px 9px 9px;
}
button {
  border-radius: 200px;
}
>>> .el-select {
  width: 100%;
}

>>> .el-input__prefix {
  left: 1px;
}
>>> .el-input__inner {
  font-size: 0.8rem;
  font-weight: 400;
}
.top {
  background: rgba(158, 158, 158, 0.1);
  border: 1px solid rgba(252, 252, 252, 0.1);
  border-radius: 6px;
  transition: all 0.1s ease-in;
}
</style>
